import Login from "../pages/auth/login";
import Register from "../pages/auth/register";
import ForgetPassword from "../pages/auth/forget-password";
import ResetPassword from "../pages/auth/reset-password";
import VerifyEmail from "../pages/auth/verify-email";
import AdminLayout from "../layouts/adminLayout";
import AdminLayoutPublic from "../layouts/adminLayoutPublic";
import Sample from "../pages/Sample";
import Print from "../pages/Print";
import ContactUs from "../pages/Profile/ContactUs";

import { lazy } from "react";
import Store from "../pages/Store/index";


const PeymentGhabs = lazy(() => import("../pages/Gabs/PeymentGhabs"));
const PeymentWater = lazy(() => import("../pages/Gabs/PeymentWater"))
const PeymentElectricity = lazy(() => import("../pages/Gabs/PeymentElectricity"));
const PeymentGas = lazy(() => import("../pages/Gabs/PeymentGas"));
const AccesptOnlinePeyment = lazy(() => import("../pages/Gabs/AccesptOnlinePeyment"));
const AccesptOnlinePeymentMobile = lazy(() => import("../pages/Gabs/AccesptOnlinePeymentMobile"));
const PeymentMobile = lazy(() => import("../pages/Gabs/PeymentMobile"));



const Dashboard = lazy(() => import("../pages/Dashboard"));
const DashboardStart = lazy(() => import("../pages/DashboardStart"));
const ShareData = lazy(() => import("../pages/Share/Index"));
const UsersList = lazy(() => import("../pages/User/List"));
const UserNew = lazy(() => import("../pages/User/New"));
const UploadUserExcelFIle = lazy(() => import("../pages/User/UploadExcel"));
const UserEdit = lazy(() => import("../pages/User/Edit"));
const UserRole = lazy(() => import("../pages/User/UserRole"));
const RoleList = lazy(() => import("../pages/Role/List"));
const RoleNew = lazy(() => import("../pages/Role/New"));
const RoleEdit = lazy(() => import("../pages/Role/Edit"));
const UpdateRolePermission = lazy(() => import("../pages/Role/UpdateRolePermission"));


const PermissionList = lazy(() => import("../pages/Permission/List"))
const PermissionNew = lazy(() => import("../pages/Permission/New"));
const PermissionEdit = lazy(() => import("../pages/Permission/Edit"))

const PermissionCategoryList = lazy(() => import("../pages/PermissionCategory/List"));
const PermissionCategoryNew = lazy(() => import("../pages/PermissionCategory/New"));
const PermissionCategoryEdit = lazy(() => import("../pages/PermissionCategory/Edit"));

const CityList = lazy(() => import("../pages/City/List"));
const CityNew = lazy(() => import("../pages/City/New"));
const CityEdit = lazy(() => import("../pages/City/Edit"));

const StateList = lazy(() => import("../pages/State/List"));
const StateNew = lazy(() => import("../pages/State/New"));
const StateEdit = lazy(() => import("../pages/State/Edit"));

const Charity = lazy(() => import("../pages/Charity/index"));

const AdvertisementList = lazy(() => import("../pages/Advertisement/List"));
const AdvertisementNew = lazy(() => import("../pages/Advertisement/New"));
const AdvertisementEdit = lazy(() => import("../pages/Advertisement/Edit"));

const ChangeForcePassword = lazy(() => import("../pages/auth/changeForcePassword"));
const ProfileEditBank = lazy(() => import("../pages/Profile/BankingInquiry/EditBank"));
const Profile = lazy(() => import("../pages/Profile/index"));
const ProfileIdentityInfo = lazy(() => import("../pages/Profile/IdentityInquiry/MainIdentityInfoForm"));
const userVerificationReportForAdmin = lazy(() => import("../pages/Profile/Reports/UserVerificationReportForAdmin"));
const bankVerificationReportForAdmin = lazy(() => import("../pages/Profile/Reports/BankVerificationReportForAdmin"));
const bankVerificationReportForUser = lazy(() => import("../pages/Profile/Reports/BankVerificationReportForUser"));
const userVerificationReportForUser = lazy(() => import("../pages/Profile/Reports/UserVerificationReportForUser"));

const UserPanel = lazy(() => import("../pages/UserPanel/index"));
const AdvPanel = lazy(() => import("../pages/AdvPanel/index"));
const ChargeSim = lazy(() => import("../pages/ChargeSim/index"));
const ChargeSimCard = lazy(() => import("../pages/ChargeSim/SimCard"));
const ChargeInternet = lazy(() => import("../pages/ChargeSim/Internet"));
const IndexInternet = lazy(() => import("../pages/ChargeSim/indexInternet"));
const Bill = lazy(() => import("../pages/ChargeSim/Bill"));
const IndexBill = lazy(() => import("../pages/ChargeSim/indexBill"));

//store
const productCategories = lazy(() => import("../pages/Store/ProductCategories"));
const store = lazy(() => import("../pages/Store/index"));
const discountCode = lazy(() => import("../pages/Store/DiscountCode"));
const productDetails = lazy(() => import("../pages/Store/ProductDetails"));
const productPartsList = lazy(() => import("../pages/Store/productPartsList"));
const userOnlineStorePurchasesForAdmin = lazy(() => import("../pages/Report/UserOnlineStorePurhcasesForAdmin"));
const userOnlineStorePurchasesForUser = lazy(() => import("../pages/Report/UserOnlineStorePurhcasesForUser"));

//Recipients
const registerRecipients = lazy(() => import("../pages/Recipients/index"));
const phisycalStores = lazy(() => import("../pages/Recipients/PhysicalStores"));
const storeDetails = lazy(() => import("../pages/Recipients/StoreDetails"));

const AdvPlanUserList = lazy(() => import("../pages/AdvPanel/UserList"));

const WalletList = lazy(() => import("../pages/Wallet/List"));
const ReportRequestPayment = lazy(() => import("../pages/Wallet/ReportRequestPayment"));
const PeriodAdvList = lazy(() => import("../pages/Report/PeriodAdvList"));
const UserChargeInternetMobileReport = lazy(() => import("../pages/Report/UserChargeInternetMobileReport"));

const UserChargeInternetMobileForAdminReport = lazy(() => import("../pages/Report/UserChargeInternetMobileForAdminReport"));
const UserChargeSimMobileForAdminReport = lazy(() => import("../pages/Report/UserChargeSimMobileForAdminReport"));
const UserChargeSimMobileReport = lazy(() => import("../pages/Report/UserChargeSimMobileReport"));

const UserRequestPaymentReport = lazy(() => import("../pages/Report/UserRequestPaymentReport"));
const UserRequestTransferToWalletReport = lazy(() => import("../pages/Report/UserRequestTransferToWalletReport"));
const UserRequestPaymentReportForAdmin = lazy(() => import("../pages/Report/UserRequestPaymentReportForAdmin"));
const UserRequestPaymentReportDailyForAdmin = lazy(() => import("../pages/Report/UserRequestPaymentReportDailyForAdmin"));
const UserRequestTransferToWalletReportForAdmin = lazy(() => import("../pages/Report/UserRequestTransferToWalletReportForAdmin"));
const AccountToIbanReportAccountToIbanReportList = lazy(() => import("../pages/Report/AccountToIbanListReport"));
const AccountToIbanReportAccountToIbanAdminReportList = lazy(() => import("../pages/Report/AccountToIbanListAdminReport"));

const CardToIbanReportCardToIbanReportList = lazy(() => import("../pages/Report/CardToIbanListReport"));
const CardToIbanReportCardToIbanAdminReportList = lazy(() => import("../pages/Report/CardToIbanListAdminReport"));


const AdvList = lazy(() => import("../pages/Report/AdvList"));
const ShowAdv = lazy(() => import("../pages/Advertisement/Show"));

const UserWallet = lazy(() => import("../pages/UserWallet/Index"));
const redirectApp = lazy(() => import("../pages/UserWallet/redirectApp"));

const UserWalletReport = lazy(() => import("../pages/UserWallet/Report"));
const UserReport = lazy(() => import("../pages/User/Report"));

const UseFullLink = lazy(() => import("../pages/UsefullLink/index"));

const UserTreeForAdmin = lazy(() => import("../pages/Report/UserTreeForAdmin"));
const UserTree2ForAdmin = lazy(() => import("../pages/Report/UserTree2ForAdmin"));
const UserTree3ForAdmin = lazy(() => import("../pages/Report/UserTree3ForAdmin"));


const ShopCategoryList = lazy(() => import("../pages/ShopCategory/List"));
const ShopCategoryNew = lazy(() => import("../pages/ShopCategory/New"));
const ShopCategoryEdit = lazy(() => import("../pages/ShopCategory/Edit"));

const MessageList = lazy(() => import("../pages/Message/List"));
const MessageNew = lazy(() => import("../pages/Message/New"));
const MessageEdit = lazy(() => import("../pages/Message/Edit"));


const ShopList = lazy(() => import("../pages/Shop/List"));
const ShopNew = lazy(() => import("../pages/Shop/New"));
const ShopEdit = lazy(() => import("../pages/Shop/Edit"));

const AcceptOnlinePayment = lazy(() => import("../pages/Wallet/AcceptOnlinePayment"));

const OnlinePaymentReportReport = lazy(() => import("../pages/Report/OnlinePaymentReport"));
const OnlinePaymentForAdminReport = lazy(() => import("../pages/Report/OnlinePaymentForAdminReport"));

const UserProfile = lazy(() => import("../pages/Profile/UserProfile"));
const Contactus = lazy(() => import("../pages/Profile/ContactUs"));

const ChargeUserWallet = lazy(() => import("../pages/ChargeUserWallet/List"));

const ComingSoon = lazy(() => import("../pages/Profile/ComingSoon"));
const UpdateApp = lazy(() => import("../pages/Profile/UpdateApp"));

const Certificate = lazy(() => import("../pages/Profile/Certificate"));
const Setting = lazy(() => import("../pages/Setting/Setting"));

const MyAdvertisementList = lazy(() => import("../pages/Advertisement/MyList"));
const MyAdvertisementNew = lazy(() => import("../pages/Advertisement/MyNew1"));
const MyAdvertisementEdit = lazy(() => import("../pages/Advertisement/MyEdit"));
const SeeAdvertisementEdit = lazy(() => import("../pages/Advertisement/See"));
const SeeMyAdvertisementEdit = lazy(() => import("../pages/Advertisement/MySee"));
const myAdvertisementSocial = lazy(() => import("../pages/Advertisement/Social"));
const advertisementSocialSee = lazy(() => import("../pages/Advertisement/SocialSee"));

const ChargeSimCardArio = lazy(() => import("../pages/ChargeSim/SimCardArio"));
const ChargeInternetArio = lazy(() => import("../pages/ChargeSim/InternetArio"));
const cardToIban = lazy(() => import("../pages/bank-services/CardToIbanBase"));
const accountToIban = lazy(() => import("../pages/bank-services/AccountToIbanBase"));

const UserProfilePublic = lazy(() => import("../pages/Profile/UserProfilePublic"));

const ChargeSimCardMobtakeran = lazy(() => import("../pages/ChargeSim/SimCardMobtakeran"));
const ChargeInternetMobtakeran = lazy(() => import("../pages/ChargeSim/InternetMobtakeran"));
const CreditFundTransactions = lazy(() => import("../pages/AdvPanel/CreditFunds/Transactions/CreditFundTransactions"));


const VehicleServices = lazy(() => import("../pages/VehicleServices/VehicleServices"));
const PeymentCar = lazy(() => import("../pages/VehicleServices/PeymentCar"));
const PeymentMotor = lazy(() => import("../pages/VehicleServices/PeymentMotor"));

export const mainRoute = [
    {
        id: 0,
        path: '/*',
        component: AdminLayout,
        isProtected: true
    },
    {
        id: 1,
        title: "ورود",
        path: '/login',
        component: Login,
        isProtected: false
    },
    {
        id: 2,
        title: "ثبت نام",
        path: '/register',
        component: Register,
        isProtected: false
    },
    {
        id: 3,
        title: "فراموشی رمز عبور",
        path: '/forget-password',
        component: ForgetPassword,
        isProtected: false
    },
    {
        id: 4,
        title: "بازنشانی رمز عبور",
        path: '/reset-password',
        component: ResetPassword,
        isProtected: false
    },
    {
        id: 5,
        title: "تایید ایمیل",
        path: '/verify-email',
        component: VerifyEmail,
        isProtected: false
    },
    {
        id: 6,
        title: "نمونه",
        path: '/sample',
        component: Sample,
        isProtected: false
    },
    {
        id: 7,
        title: "چاپ فاکتور",
        path: '/print',
        component: Print,
        isProtected: false
    },
    {
        id: 8,
        title: "درحال بروزرسانی",
        path: '/coming-soon',
        component: ComingSoon,
        isProtected: false
    },
    {
        id: 9,
        title: "redirectApp",
        path: "/redirectapp",
        component: redirectApp,
        isProtected: false
    },
    {
        id: 10,
        title: "وضعیت پرداخت",
        path: "/wallet/verification/:id",
        component: AcceptOnlinePayment,
        isProtected: false
    },
    {
        id: 11,
        title: "بروزرسانی اپلیکیشن",
        path: '/update-app',
        component: UpdateApp,
        isProtected: false
    },
    {
        id: 12,
        title: "فرم لندینگ",
        path: '/',
        component: AdminLayoutPublic,
        isProtected: false
    },
    {
        id: 13,
        title: "ارتباط با ما",
        path: "/contactus",
        component: ContactUs,
        isProtected: false
    },
    {
        id: 14,
        title: "پروفایل کاربر",
        path: "/profile-public",
        component: UserProfilePublic,
        isProtected: false
    }
]


export const panelRoutes = [
    {
        id: 0,
        title: "داشبورد",
        path: "/dashboard",
        component: Dashboard,
        permission: ""
    },
    {
        id: 1,
        title: "کاربران | لیست",
        path: "/user/list",
        component: UsersList,
        permission: "UserUserList"
    },
    {
        id: 2,
        title: "کاربران | جدید",
        path: "/user/new",
        component: UserNew,
        permission: "UserAddNewUser"
    },
    {
        id: 3,
        title: "کاربران | ویرایش",
        path: "/user/edit/:id",
        component: UserEdit,
        permission: "UserUserItem"
    },
    {
        id: 4,
        title: "کاربران | ویرایش نقش",
        path: "/user/user-role/:id",
        component: UserRole,
        permission: "UserUserItem"
    },
    {
        id: 5,
        title: "نقش ها | لیست",
        path: "/config/role/list",
        component: RoleList,
        permission: "RoleRoleList"
    },
    {
        id: 6,
        title: "نقش ها | جدید",
        path: "/config/role/new",
        component: RoleNew,
        permission: "RoleAddRole"
    },
    {
        id: 7,
        title: "نقش ها | ویرایش",
        path: "/config/role/edit/:id",
        component: RoleEdit,
        permission: "RoleGetRoleItem"
    },
    {
        id: 8,
        title: "سطح دسترسی نقش ها | ویرایش",
        path: "/config/role/update-permission/:id",
        component: UpdateRolePermission,
        permission: "RoleGetRoleItem"
    },
    {
        id: 9,
        title: "سطح دسترسی ها | لیست",
        path: "/config/permission/list",
        component: PermissionList,
        permission: "PermissionPermissionList"
    },
    {
        id: 10,
        title: "سطح دسترسی ها | جدید",
        path: "/config/permission/new",
        component: PermissionNew,
        permission: "PermissionAddPermission"
    },
    {
        id: 11,
        title: "سطح دسترسی ها | ویرایش",
        path: "/config/permission/edit/:id",
        component: PermissionEdit,
        permission: "PermissionGetPermissionItem"
    },
    {
        id: 12,
        title: "دسته بندی سطح دسترسی ها | لیست",
        path: "/config/permission-category/list",
        component: PermissionCategoryList,
        permission: "PermissionCategoryPermissionCategoryList"
    },
    {
        id: 13,
        title: "دسته بندی سطح دسترسی ها | جدید",
        path: "/config/permission-category/new",
        component: PermissionCategoryNew,
        permission: "PermissionCategoryAddPermissionCategory"
    },
    {
        id: 14,
        title: "دسته بندی سطح دسترسی ها | ویرایش",
        path: "/config/permission-category/edit/:id",
        component: PermissionCategoryEdit,
        permission: "PermissionCategoryPermissionCategoryItem"
    },
    {
        id: 15,
        title: "کاربران | آپلود فایل اکسل",
        path: "/user/upload-excel",
        component: UploadUserExcelFIle,
        permission: "UserUploadExcelFile"
    },
    {
        id: 16,
        title: "ویرایش رمز عبور | ثبت",
        path: "/change-password",
        component: ChangeForcePassword,
        permission: "UserChangeUserPasswordByUser"
    },
    {
        id: 17,
        title: "شهرها | ویرایش",
        path: "/city/edit/:id",
        component: CityEdit,
        permission: "CityEditCity"
    },
    {
        id: 18,
        title: "شهرها | لیست",
        path: "/city/list",
        component: CityList,
        permission: "CityCityList"
    },
    {
        id: 19,
        title: "شهرها | ثبت",
        path: "/city/new",
        component: CityNew,
        permission: "CityAddCity"
    },
    {
        id: 20,
        title: "استان | ویرایش",
        path: "/state/edit/:id",
        component: StateEdit,
        permission: "StateEditState"
    },
    {
        id: 21,
        title: "استان | لیست",
        path: "/state/list",
        component: StateList,
        permission: "StateStateList"
    },
    {
        id: 22,
        title: "استان | ثبت",
        path: "/state/new",
        component: StateNew,
        permission: "StateAddState"
    }, {
        id: 23,
        title: "تبلیغات | ویرایش",
        path: "/advertisement/edit/:id",
        component: AdvertisementEdit,
        permission: "AdvertisementEditAdvertisement"
    },
    {
        id: 24,
        title: "تبلیغات | لیست",
        path: "/advertisement/list",
        component: AdvertisementList,
        permission: "AdvertisementAdvertisementList"
    },
    {
        id: 25,
        title: "تبلیغات | ثبت",
        path: "/advertisement/new",
        component: AdvertisementNew,
        permission: "AdvertisementAddAdvertisement"
    },
    {
        id: 26,
        title: "پنل کاربری",
        path: "/user-panel",
        component: UserPanel,
        permission: "UserEditCurrentUser"
    },
    {
        id: 27,
        title: "پنل تبلیغات",
        path: "/adv-panel",
        component: AdvPanel,
        permission: "UserEditCurrentUser"
    },
    {
        id: 28,
        title: "خدمات شارژ سیم کارت",
        path: "/charge-sim",
        component: ChargeSim,
        permission: "UserEditCurrentUser"
    },
    {
        id: 29,
        title: " شارژ سیم کارت",
        path: "/charge-simcard",
        component: ChargeSimCard,
        permission: "UserEditCurrentUser"
    },
    {
        id: 30,
        title: " شارژ اینترنت",
        path: "/charge-internet",
        component: ChargeInternet,
        permission: "UserEditCurrentUser"
    },
    {
        id: 31,
        title: "کیف پول | لیست",
        path: "/wallet/list",
        component: WalletList,
        permission: "WalletGetAdminWalletList"
    },
    {
        id: 32,
        title: "گزارش تبلیغات زمان دار | لیست",
        path: "/report/period-adv-list",
        component: PeriodAdvList,
        permission: "CommissionAdvertisementAdminChargeAdv"
    },
    {
        id: 33,
        title: "گزارش همه تبلیغات | لیست",
        path: "/report/adv-list",
        component: AdvList,
        permission: "CommissionCommissionForAdmin"
    },
    {
        id: 34,
        title: "نمایش تبلیغات | لیست",
        path: "/adv/show-adv",
        component: ShowAdv,
        permission: "AdvertisementShowAdv"
    }, {
        id: 35,
        title: "لیست کاربران",
        path: "/adv-panel/userList",
        component: AdvPlanUserList,
        permission: "UserSubSetUser"
    },
    {
        id: 36,
        title: " شارژ اینترنت",
        path: "/index-internet",
        component: IndexInternet,
        permission: "UserEditCurrentUser"
    },
    {
        id: 37,
        title: "کیف پول",
        path: "/user-wallet",
        component: UserWallet,
        permission: "UserEditCurrentUser"
    },
    {
        id: 38,
        title: "لینک های مفید",
        path: "/usefull-link",
        component: UseFullLink,
        permission: "UserEditCurrentUser"
    },
    {
        id: 39,
        title: "کیف پول کاربر",
        path: "/user-wallet-report",
        component: UserWalletReport,
        permission: "WalletGetUserWalletList"
    },
    {
        id: 40,
        title: "کیف پول | لیست",
        path: "/wallet/report-request-payment",
        component: ReportRequestPayment,
        permission: "WalletRequestPaymentListForAdmin"
    },
    {
        id: 41,
        title: "معرفی به دوستان",
        path: "/share",
        component: ShareData,
        permission: "WalletGetUserWalletList"
    },
    {
        id: 42,
        title: "پرداخت قبض",
        path: "/bill-payment",
        component: Bill,
        permission: "UserEditCurrentUser"
    },
    {
        id: 43,
        title: "گزارش خرید شارژ | لیست",
        path: "/report/user-chard-sim-report/list",
        component: UserChargeSimMobileReport,
        permission: "ChargeMobileGetUserSimChargeList"
    },
    {
        id: 44,
        title: "گزارش خرید شارژ برای مدیر | لیست",
        path: "/report/user-chard-sim-report-admin/list",
        component: UserChargeSimMobileForAdminReport,
        permission: "ChargeMobileGetUserSimChargeListForAdmin"
    },
    {
        id: 45,
        title: "گزارش خرید اینترنت | لیست",
        path: "/report/user-chard-internet-report/list",
        component: UserChargeInternetMobileReport,
        permission: "ChargeMobileGetUserInternetChargeList"
    },
    {
        id: 46,
        title: "گزارش خرید اینترنت برای مدیر | لیست",
        path: "/report/user-chard-internet-report-admin/list",
        component: UserChargeInternetMobileForAdminReport,
        permission: "ChargeMobileGetUserInternetChargeListForAdmin"
    },
    {
        id: 47,
        title: "پرداخت قبض",
        path: "/index-bill",
        component: IndexBill,
        permission: "UserEditCurrentUser"
    },
    {
        id: 48,
        title: "درخواست برداشت | لیست",
        path: "/report/user-request-payment/list",
        component: UserRequestPaymentReport,
        permission: "RequestPaymentGetUserRequestPayment"
    },
    {
        id: 49,
        title: "درخواست انتقال به کیف پول | لیست",
        path: "/report/user-request-transfer-wallet/list",
        component: UserRequestTransferToWalletReport,
        permission: "RequestPaymentGetUserRequestTransferCommissionToWallet"
    },
    {
        id: 50,
        title: "درخواست برداشت | لیست",
        path: "/report/user-request-payment-admin/list",
        component: UserRequestPaymentReportForAdmin,
        permission: "RequestPaymentGetUserRequestPaymentForAdmin"
    },
    {
        id: 51,
        title: "درخواست انتقال به کیف پول | لیست",
        path: "/report/user-request-transfer-wallet-admin/list",
        component: UserRequestTransferToWalletReportForAdmin,
        permission: "RequestPaymentGetUserRequestTransferCommissionToWalletForAdmin"
    },
    {
        id: 52,
        title: "پروفایل",
        path: "/profile",
        component: Profile,
        permission: "UserEditCurrentUser"
    },
    {
        id: 53,
        title: "ویرایش اطلاعات بانک",
        path: "/profile-bank",
        component: ProfileEditBank,
        permission: "UserEditCurrentUser"
    }, {
        id: 54,
        title: "نمایش درختی کاربران",
        path: "/user-tree/:id",
        component: UserTreeForAdmin,
        permission: "UserUserTree"
    }, {
        id: 55,
        title: "دسته بندی فروشگاه ها | ویرایش",
        path: "/shop-category/edit/:id",
        component: ShopCategoryEdit,
        permission: "ShopCategoryEditShopCategory"
    },
    {
        id: 56,
        title: "دسته بندی فروشگاه ها | لیست",
        path: "/shop-category/list",
        component: ShopCategoryList,
        permission: "ShopCategoryShopCategoryList"
    },
    {
        id: 57,
        title: "دسته بندی فروشگاه ها | ثبت",
        path: "/shop-category/new",
        component: ShopCategoryNew,
        permission: "ShopCategoryAddShopCategory"
    }, {
        id: 58,
        title: "فروشگاه ها | ویرایش",
        path: "/shop/edit/:id",
        component: ShopEdit,
        permission: "ShopEditShop"
    },
    {
        id: 59,
        title: " فروشگاه ها | لیست",
        path: "/shop/list",
        component: ShopList,
        permission: "ShopShopList"
    },
    {
        id: 60,
        title: " فروشگاه ها | ثبت",
        path: "/shop/new",
        component: ShopNew,
        permission: "ShopAddShop"
    }, {
        id: 61,
        title: "پرداخت های آنلاین",
        path: "/report/online-payment-report/list",
        component: OnlinePaymentReportReport,
        permission: "OnlinePaymentBankOnlinePaymentBankList"
    }, {
        id: 62,
        title: "پرداخت های آنلاین  - مدیر",
        path: "/report/online-payment-report-for-admin/list",
        component: OnlinePaymentForAdminReport,
        permission: "OnlinePaymentBankOnlinePaymentBankListForAdmin"
    }, {
        id: 63,
        title: "پروفایل کاربر",
        path: "/user-profile",
        component: UserProfile,
        permission: "UserEditCurrentUser"

    }, {
        id: 64,
        title: "ارتباط با ما",
        path: "/contact-us",
        component: Contactus,
        permission: "UserEditCurrentUser"

    },
    {
        id: 65,
        title: "خیریه",
        path: "/charity",
        component: Charity,
        permission: "UserEditCurrentUser"

    },
    {
        id: 66,
        title: "شارژ کاربران",
        path: "/charge-user-wallet",
        component: ChargeUserWallet,
        permission: "ChargeUserWalletGetCountUserWithCategory"

    }, {
        id: 67,
        title: "مجوز ها",
        path: "/cert",
        component: Certificate,
        permission: "UserEditCurrentUser",
        isPublic: true
    },
    {
        id: 68,
        title: "تنظیمات",
        path: "/setting",
        component: Setting,
        permission: "SettingChangeActiveSiteStatus"

    }, {
        id: 69,
        title: "نمایش درختی کاربران دودویی",
        path: "/user-tree2/:id",
        component: UserTree2ForAdmin,
        permission: "UserUserTree2"
    }, {
        id: 70,
        title: "نمایش درختی کاربران خطی",
        path: "/user-tree3/:id",
        component: UserTree3ForAdmin,
        permission: "UserUserTree3"
    },
    {
        id: 71,
        title: "تراکنش‌ها",
        path: "/report",
        component: UserReport,
        permission: "WalletGetUserWalletList"
    },
    {
        id: 72,
        title: "پیام ها | ویرایش",
        path: "/message/edit/:id",
        component: MessageEdit,
        permission: "MessageEditMessage"
    },
    {
        id: 73,
        title: "پیام ها | لیست",
        path: "/message/list",
        component: MessageList,
        permission: "MessageMessageList"
    },
    {
        id: 74,
        title: "پیام ها | ثبت",
        path: "/message/new",
        component: MessageNew,
        permission: "MessageAddMessage"
    },
    {
        id: 75,
        title: "درخواست برداشت | لیست روزانه",
        path: "/report/user-request-payment-admin/daily",
        component: UserRequestPaymentReportDailyForAdmin,
        permission: "RequestPaymentGetUserRequestPaymentForAdmin"
    },
    {
        id: 76,
        title: "تبلیغات | من",
        path: "/my-advertisement/list",
        component: MyAdvertisementList,
        permission: "AdvertisementMyAdvertisementList"
    },
    {
        id: 77,
        title: "تبلیغات | ایجاد",
        path: "/my-advertisement/new",
        component: MyAdvertisementNew,
        permission: "AdvertisementAddMyAdvertisement"
    },
    {
        id: 78,
        title: "تبلیغات | ویرایش",
        path: "/my-advertisement/edit1/:id",
        component: MyAdvertisementEdit,
        permission: "AdvertisementEditMyAdvertisement"
    },
    {
        id: 79,
        title: "تبلیغات | بررسی",
        path: "/advertisement/see/:id",
        component: SeeAdvertisementEdit,
        permission: "AdvertisementSeeAdvertisement"
    },
    {
        id: 80,
        title: "تبلیغات | مشاهده",
        path: "/my-advertisement/see1/:id",
        component: SeeMyAdvertisementEdit,
        permission: "AdvertisementSeeAdvertisement"
    },
    {
        id: 81,
        title: "اجتماعی | ویرایش",
        path: "/my-advertisement/social/:id",
        component: myAdvertisementSocial,
        permission: "AdvertisementEditAdvertisementSocial"
    },
    {
        id: 82,
        title: "اجتماعی | مشاهده",
        path: "/advertisement/social-see/:id",
        component: advertisementSocialSee,
        permission: "AdvertisementAdvertisementSocial"
    },
    {
        id: 83,
        title: " شارژ سیم کارت",
        path: "/charged-simcard",
        component: ChargeSimCardArio,
        permission: "UserEditCurrentUser"
    },
    {
        id: 84,
        title: " شارژ اینترنت",
        path: "/charged-internet",
        component: ChargeInternetArio,
        permission: "UserEditCurrentUser"
    },
    {
        id: 85,
        title: "تبدیل کارت به شماره ",
        path: '/card-to-iban',
        component: cardToIban,
        permission: "UserEditCurrentUser"
    },
    {
        id: 86,
        title: "تبدیل کارت به شماره ",
        path: '/account-to-iban',
        component: accountToIban,
        permission: "UserEditCurrentUser"
    },
    {
        id: 87,
        title: " شارژ سیم کارت",
        path: "/mob-charge-simcard",
        component: ChargeSimCardMobtakeran,
        permission: "UserEditCurrentUser"
    },
    {
        id: 88,
        title: " شارژ اینترنت",
        path: "/mob-charge-internet",
        component: ChargeInternetMobtakeran,
        permission: "UserEditCurrentUser"
    },
    {
        id: 89,
        title: "کارت اعتبار خرید",
        path: "/adv-panel/credit-fund",
        component: CreditFundTransactions,
        permission: "UserEditCurrentUser"
    },
    {
        id: 90,
        title: "فروشگاه",
        path: "/store/products",
        component: store,
        permission: "UserEditCurrentUser"
    },
    {
        id: 91,
        title: "جزئیات محصول",
        path: "/store/product-detail/:id",
        component: productDetails,
        permission: "UserEditCurrentUser"
    },
    {
        id: 92,
        title: "گزارش تبدیل حساب به شبا | لیست",
        path: "/report/account-to-iban-report/list",
        component: AccountToIbanReportAccountToIbanReportList,
        permission: "BankProfile"
    },
    {
        id: 93,
        title: "گزارش تبدیل حساب به شبا | لیست",
        path: "/report/account-to-iban-report-admin/list",
        component: AccountToIbanReportAccountToIbanAdminReportList,
        permission: "BankProfileForAdmin"
    },
    {
        id: 94,
        title: "گزارش تبدیل کارت به شبا | لیست",
        path: "/report/card-to-iban-report/list",
        component: CardToIbanReportCardToIbanReportList,
        permission: "BankProfileCardToIban"
    },
    {
        id: 95,
        title: "گزارش تبدیل کارت به شبا | لیست",
        path: "/report/card-to-iban-report-admin/list",
        component: CardToIbanReportCardToIbanAdminReportList,
        permission: "BankProfileCardToIbanForAdmin"
    },
    {
        id: 96,
        title: "لیست پارتهای محصول",
        path: "/store/product-parts/:id",
        component: productPartsList,
        permission: "UserEditCurrentUser"
    },
    {
        id: 97,
        title: "گزارش",
        path: "report/user-online-store-report-admin/list",
        component: userOnlineStorePurchasesForAdmin,
        permission: "onlineStoreReportForAdmin"
    },
    {
        id: 98,
        title: "گزارش",
        path: "report/user-online-store-report-user/list",
        component: userOnlineStorePurchasesForUser,
        permission: "onlineStoreReportForUser"
    },
    {
        id: 99,
        title: "اطلاعات هویتی",
        path: "profile/identity-Info",
        component: ProfileIdentityInfo,
        permission: "UserEditCurrentUser"
    },
    {
        id: 100,
        title: "گزارش احراز هویت",
        path: "report/user-verification-admin/list",
        component: userVerificationReportForAdmin,
        permission: "userVerificationReportForAdmin"
    },
    {
        id: 101,
        title: "گزاش استعلام حساب",
        path: "report/bank-verification-user-admin/list",
        component: bankVerificationReportForAdmin,
        permission: "userVerificationReportForAdmin"
    },
    {
        id: 102,
        title: "گزارش احراز هویت",
        path: "report/user-verification/list",
        component: userVerificationReportForUser,
        permission: "userVerificationReportForUser"
    },
    {
        id: 103,
        title: "گزاش استعلام حساب",
        path: "report/bank-verification-user/list",
        component: bankVerificationReportForUser,
        permission: "userVerificationReportForUser"
    },
    {
        id: 104,
        title: "خرید کد تخفیف",
        path: "store/discount-code",
        component: discountCode,
        permission: "UserEditCurrentUser"
    },
    {
        id: 105,
        title: "پذیرندگان",
        path: "recipients/register",
        component: registerRecipients,
        permission: "UserEditCurrentUser"
    },
    {
        id: 106,
        title: "فروشگاه فیزیکی",
        path: "recipients/physical-store",
        component: phisycalStores,
        permission: "UserEditCurrentUser"
    },
    {
        id: 107,
        title: "قبوض خدمات ",
        path: "/Gabspeyment",
        component: PeymentGhabs,
        permission: "UserEditCurrentUser"
    },
    {
        id: 108,
        title: "قبوض خدمات آب",
        path: "/PeymentWater",
        component: PeymentWater,
        permission: "UserEditCurrentUser"
    },
    {
        id: 109,
        title: "قبوض خدمات برق",
        path: "/PeymentElectricity",
        component: PeymentElectricity,
        permission: "UserEditCurrentUser"
    },
    {
        id: 110,
        title: "قبوض خدمات گاز",
        path: "/GabspeymentGas",
        component: PeymentGas,
        permission: "UserEditCurrentUser"
    },
    //{
    // id: 111,
    //  title: "قبوض خدمات تلفن",
    // path: "/PeymentTelphone",
    //  component: PeymentTelphone, 
    //  permission: "UserEditCurrentUser"
    //},
    {
        id: 112,
        title: "تائیدپرداخت قبض",
        path: "/AccesptOnlinePeyment",
        component: AccesptOnlinePeyment,
        permission: "UserEditCurrentUser"
    },
    {
        id: 113,

        title: "قبوض خدمات همراه",
        path: "/PeymentMobile",
        component: PeymentMobile,
        permission: "UserEditCurrentUser"
    },
    {
        id: 114,
        title: "تائیدپرداخت قبض موبایل ",
        path: "/AccesptOnlinePeymentMobile",
        component: AccesptOnlinePeymentMobile,
        permission: "UserEditCurrentUser"
    },
    {
        id: 115,
        title: "گروههای محصولات",
        path: "store/product-categories",
        component: productCategories,
        permission: "UserEditCurrentUser"
    },
    {
        id: 116,
        title: "قبوض خدمات خودرو و موتور",
        path: "/VehicleServices",
        component: VehicleServices,
        permission: "UserEditCurrentUser"
    },
    {
        id: 117,
        title: "قبوض خلافی خودرو",
        path: "/PeymentCar",
        component: PeymentCar,
        permission: "UserEditCurrentUser"
    },
    {
        id: 118,
        title: "قبوض خلافی موتور",
        path: "/PeymentMotor",
        component: PeymentMotor,
        permission: "UserEditCurrentUser"
    },
    {
        id: 119,
        title: "جزئیات فروشگاه",
        path: "/store-details/:id", // <-- اینجا :id اضافه شد
        component: storeDetails,
        permission: "UserEditCurrentUser"
    }


]
